import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PaidAvailability.css';

const PaidAvailability = ({ userData }) => {
  const [availabilityData, setAvailabilityData] = useState({ students: [], availability: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [checkedSlots, setCheckedSlots] = useState({});
  const [notification, setNotification] = useState(null);

  // Days of the week (0 = Sunday, 1 = Monday, etc.)
  const daysOfWeek = [ 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const shortDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  // Time slots mapping (Slot number to time)
  const slotToTime = {
    8: '8:00 AM',
    9: '9:00 AM',
    10: '10:00 AM',
    11: '11:00 AM',
    12: '12:00 PM',
    13: '1:00 PM',
    14: '2:00 PM',
    15: '3:00 PM',
    16: '4:00 PM',
    17: '5:00 PM',
    18: '6:00 PM',
    19: '7:00 PM',
    20: '8:00 PM',
    21: '9:00 PM',
    22: '10:00 PM'
  };
  const slotToTimeview = {
    8: '8:00 AM',
    9: '9:00 AM',
    10: '10:00 AM',
    11: '11:00 AM',
    12: '12:00 PM',
    13: '1:00 PM',
    14: '2:30 PM',
    15: '3:30 PM',
    16: '4:30 PM',
    17: '5:30 PM',
    18: '6:30 PM',
    19: '7:30 PM',
    20: '8:30 PM',
    21: '9:30 PM',
    22: '10:30 PM'
  };
  // Fetch paid availability data from API
  useEffect(() => {
    const fetchAvailabilityData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teacher/paidavailability/${userData.id}`
        );
        setAvailabilityData(response.data);
        
        // Initialize checked slots from API
        const initialChecked = {};
        response.data.availability.forEach(slot => {
          if (slot.Checkteacher === 1) {
            const slotKey = `${slot.DayoftheWeek}-${slot.Slot}`;
            initialChecked[slotKey] = true;
          }
        });
        setCheckedSlots(initialChecked);
      } catch (error) {
        console.error('Error fetching availability:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAvailabilityData();
  }, [userData.id]);

  // Submit availability changes to API
  const submitAvailability = async (dayIndex, slot) => {
    console.log(userData.id+" "+dayIndex+" "+slot+" "+!checkedSlots[`${dayIndex}-${slot}`]);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/submitpaidavailability`, {
        teacherId: userData.id,
        dayOfWeek: dayIndex,
        slot: slot,
        isAvailable: !checkedSlots[`${dayIndex}-${slot}`]
      });
      
      showNotification(
        `Slot ${slotToTimeview[slot]} on ${shortDays[dayIndex]} ${!checkedSlots[`${dayIndex}-${slot}`] ? 'checked' : 'unchecked'}`,
        !checkedSlots[`${dayIndex}-${slot}`] ? 'green' : 'red'
      );
    } catch (error) {
      console.error('Error submitting availability:', error);
      showNotification('Failed to update availability', 'red');
    }
  };

  const handleCheckboxChange = async (dayIndex, slot) => {
    const slotKey = `${dayIndex}-${slot}`;
    const newChecked = !checkedSlots[slotKey];
    
    // Optimistic UI update
    setCheckedSlots(prev => ({
      ...prev,
      [slotKey]: newChecked
    }));
    
    // Submit to API
    await submitAvailability(dayIndex, slot);
  };

  const showNotification = (message, color) => {
    setNotification({ message, color });
    setTimeout(() => setNotification(null), 3000);
  };

  // Get student for a specific day and slot
  const getStudentForSlot = (dayIndex, slot) => {
    return availabilityData.students.find(
      student => student.DayoftheWeek === dayIndex && student.Slot === slot
    );
  };

  if (isLoading) {
    return (
      <div className="pa-loading-container">
        <div className="pa-loading-spinner"></div>
        <p>Loading Paid Availability...</p>
      </div>
    );
  }

  return (
    <div className="pa-container">
      {notification && (
        <div className="pa-notification" style={{ backgroundColor: notification.color }}>
          {notification.message}
        </div>
      )}

      <div className="pa-table">
        <div className="pa-table-header text-center">
          <h3>Paid Availability</h3>
          Choose the slots that you are available for Paid sessions for every Week.


        </div>

        <div className="pa-table-body">
          <div className="pa-time-column">
            <div className="pa-time-header">Time</div>
            {Object.entries(slotToTimeview).map(([slot, time]) => (
              <div key={slot} className="pa-time-slot-label">{time}</div>
            ))}
          </div>

          <div className="pa-days-container">
            <div className="pa-days-header">
              {daysOfWeek.map((day, index) => (
                <div key={index} className="pa-day-header">
                  {shortDays[index]}
                </div>
              ))}
            </div>

            <div className="pa-grid">
              {Object.keys(slotToTime).map(slot => (
                <div key={slot} className="pa-time-row">
                  {daysOfWeek.map((day, dayIndex) => {
                    dayIndex = dayIndex +1;
                    const slotNum = parseInt(slot);
                    const student = getStudentForSlot(dayIndex, slotNum);
                    const isChecked = checkedSlots[`${dayIndex}-${slotNum}`];
                    
                    return (
                      <div key={`${dayIndex}-${slot}`} className="pa-time-slot">
                        {student ? (
                            student.sessionsremainig === 0 ?
                                <div className="pa-student-slot pa-no-sessions">
                                    <div className="pa-student-name">
                                    {student.FirstName} {student.LastName}
                                    </div>
                                    <div className="pa-sessions-remaining">
                                    Update Pending...
                                    </div>
                                </div>
                                :
                            <div className="pa-student-slot pa-has-sessions">
                                <div className="pa-student-name">
                                {student.FirstName} {student.LastName}
                                </div>
                                <div className="pa-sessions-remaining">
                                    {slotToTimeview[slot]}
                                </div>
                            </div>
                  
                        ) : (
                          <div 
                            className={`pa-availability-slot ${isChecked ? 'pa-checked' : ''}`}
                            onClick={() => handleCheckboxChange(dayIndex, slotNum)}
                          >
                            {isChecked ? (
                                 <div 
                                    className="pa-student-slot pa-available-text" >
                                    <div className="pa-student-name">
                                     Paid Available
                                    </div>
                                    <div className="pa-sessions-remaining">
                                        {slotToTimeview[slot]}
                                    </div>
                                </div>   




                             
                            ) : (
                              <div className="pa-slot-time">{slotToTimeview[slot]}</div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaidAvailability;